import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';

const FilterTabs = ({ categories, activeCategory, onCategoryChange }) => {
  const { isDark } = useTheme();

  return (
    <div className="flex flex-wrap justify-center gap-2 mb-8">
      {categories.map((category) => (
        <motion.button
          key={category}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onCategoryChange(category)}
          className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
            activeCategory === category
              ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/25'
              : isDark
                ? 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                : 'bg-white text-gray-700 hover:bg-gray-100 shadow-sm'
          }`}
        >
          {category}
        </motion.button>
      ))}
    </div>
  );
};

export default FilterTabs;